var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouriteOptionActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouriteOptionActive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.4574591,11.3295782 C24.9495438,10.8290139 25.1232502,10.0943653 24.910998,9.41144505 C24.6982452,8.72852485 24.1440867,8.24102328 23.4632777,8.13756636 L17.4100847,7.21951678 C17.1522783,7.18032855 16.9295136,7.01155791 16.8143768,6.76754588 L14.108161,1.0429294 C13.8042999,0.399719935 13.187567,0 12.5002503,0 C11.8134342,0 11.1967013,0.399719935 10.8928402,1.0429294 L8.18612382,6.76806839 C8.070987,7.01208042 7.84772169,7.18085106 7.58991534,7.22003929 L1.53672233,8.13808887 C0.856413917,8.24102328 0.301754815,8.72904736 0.0890020005,9.41196756 C-0.123250219,10.0948878 0.0504561965,10.8295364 0.542540941,11.3301007 L4.92224535,15.7860636 C5.10896723,15.9762572 5.19456895,16.2500523 5.1505166,16.5175772 L4.11728882,22.8096393 C4.02567996,23.3634996 4.16484533,23.9022071 4.5082534,24.3270075 C5.04188752,24.9890273 5.97349455,25.190716 6.7183797,24.7821134 L12.1318125,21.8111232 C12.3580814,21.6872884 12.6429198,21.6883334 12.8686881,21.8111232 L18.2826215,24.7821134 C18.5459344,24.9268486 18.8267681,25 19.1166125,25 C19.6457413,25 20.1473373,24.7544204 20.4922472,24.3270075 C20.8361559,23.9022071 20.9748206,23.3624545 20.8832118,22.8096393 L19.8494834,16.5175772 C19.805431,16.2495297 19.8910328,15.9762572 20.0777547,15.7860636 L24.4574591,11.3295782 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFavouriteOptionActive",
    fill: "#10C2E1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouriteOptionActive);
export default __webpack_public_path__ + "static/media/icFavouriteOptionActive.5f9fd87018498c3076e10479a1328706.svg";
export { ForwardRef as ReactComponent };